import React, { useMemo } from 'react';
import { isEmpty } from "lodash";
import GenericPullConfigListing from '../GenericPullConfigListing';
import SemgrepMappingForm from './SemgrepMappingForm';
import SemgrepCredentialsForm from './SemgrepCredentialsForm';
import { columnRenderArrayData } from "utils/tableUtils";

const SemgrepConfigListing = (props) => {
    const columns = useMemo(
        () => [
          {
            title: "Project",
            dataIndex: "projectName",
            width: 170,
            render: columnRenderArrayData,
          },
          {
            title: "Scan Type",
            dataIndex: "scanType",
            width: 130,
            render: (scanType) => isEmpty(scanType) ? "All" :  columnRenderArrayData(scanType),
          },
        ],
        [],
      );
    
    return (<GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={SemgrepMappingForm}
        CredentialsForm={SemgrepCredentialsForm}
        extraColumns={columns}
     />)
};

export default SemgrepConfigListing;
